var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slo-rep-locator"},[_c('SloTabs',{attrs:{"default-value":"tab-1","items":"start"}},[_c('SloTab',{attrs:{"name":"tab-1","title":_vm._f("t")('Online Distributors')}},[_c('SloOnlineDistributors')],1),_vm._v(" "),_c('SloTab',{attrs:{"name":"tab-2","title":_vm._f("t")('Local Distributors & Reps')}},[_c('SloRepMap')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }